import { Component } from '@angular/core';
import { membersuiteTaxProductEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Tax Products') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitetaxproduct-form',
    templateUrl: './membersuitetaxproduct.form.component.html'
})
export class membersuiteTaxProductFormComponent extends BaseFormComponent {
    public record!: membersuiteTaxProductEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

